var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button", "aria-label": "Close" },
            on: {
              click: function ($event) {
                return _vm.emitCancelEvent(_vm.modal_id)
              },
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "modal-title" }, [_vm._v("拠点追加")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-note" }, [
        _vm._v(
          "\n      登録内容を反映するには「登録」ボタンを押して、この画面が閉じた後のページ下部にある「変更を適用」を押してください。\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("状態"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c(
                "div",
                { staticClass: "m-t-xs", attrs: { id: "add_location_status" } },
                [
                  _vm._l(_vm.options.status, function (v, k) {
                    return [
                      _c(
                        "label",
                        {
                          key: `status-label-${k}`,
                          staticClass: "m-r-md",
                          attrs: { for: "add_location_status_" + k },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.location.location_status,
                                expression: "location.location_status",
                              },
                            ],
                            key: `status-${k}`,
                            attrs: {
                              type: "radio",
                              name: "location_status",
                              id: "add_location_status_" + k,
                            },
                            domProps: {
                              value: k,
                              checked: _vm._q(_vm.location.location_status, k),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(
                                  _vm.location,
                                  "location_status",
                                  k
                                )
                              },
                            },
                          }),
                          _vm._v(_vm._s(v) + "\n                "),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("拠点名"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.location_name,
                    expression: "location.location_name",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "location_name",
                  placeholder: "例）本社、◯◯支店など",
                  maxlength: "40",
                },
                domProps: { value: _vm.location.location_name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.location, "location_name", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("所在地"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-4" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("span", { staticClass: "input-group-addon" }, [
                  _vm._v("〒"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.location.zip,
                      expression: "location.zip",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "zip",
                    placeholder: "例）123-4567",
                    maxlength: "8",
                  },
                  domProps: { value: _vm.location.zip },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.location, "zip", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.location.pref,
                      expression: "location.pref",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "pref" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.location,
                        "pref",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.options.pref, function (v, i) {
                  return _c("option", { key: i, domProps: { value: i } }, [
                    _vm._v(
                      "\n                " + _vm._s(v) + "\n              "
                    ),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "col-xs-9 col-xs-offset-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.address,
                    expression: "location.address",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "address",
                  placeholder: "市区町村・番地・ビル名",
                  maxlength: "100",
                },
                domProps: { value: _vm.location.address },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.location, "address", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("TEL"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.tel,
                    expression: "location.tel",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "tel",
                  placeholder: "例）123-456-7890",
                  maxlength: "40",
                },
                domProps: { value: _vm.location.tel },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.location, "tel", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("FAX"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.fax,
                    expression: "location.fax",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "fax",
                  placeholder: "例）123-456-7890",
                  maxlength: "40",
                },
                domProps: { value: _vm.location.fax },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.location, "fax", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("営業時間"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.business_hours,
                    expression: "location.business_hours",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "business_hours",
                  placeholder: "例）平日9:00-18:00（土日・祝休み）",
                  maxlength: "100",
                },
                domProps: { value: _vm.location.business_hours },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.location,
                      "business_hours",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "form_note m-t-sm m-b-none" }, [
                _vm._v("25文字まで"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("アクセス情報"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.access,
                    expression: "location.access",
                  },
                ],
                staticClass: "form-control",
                attrs: { name: "access" },
                domProps: { value: _vm.location.access },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.location, "access", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "form_note m-t-sm" }, [
                _vm._v(
                  "\n              最寄り駅等から所在地への道順を記載してください。 500文字まで\n            "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "hr-line-dashed" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-xs-3 control-label" }, [
              _vm._v("Googleマップ"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-9" }, [
              _c(
                "div",
                { staticClass: "m-t-xs", attrs: { id: "add_map_type" } },
                [
                  _vm._l(_vm.options.google_map, function (v, k) {
                    return [
                      _c(
                        "label",
                        {
                          key: `google_map-label-${k}`,
                          staticClass: "m-r-md",
                          attrs: { for: "add_map_type_" + k },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.location.map_type,
                                expression: "location.map_type",
                              },
                            ],
                            key: `map-${k}`,
                            attrs: {
                              type: "radio",
                              name: "map_type",
                              id: "add_map_type_" + k,
                            },
                            domProps: {
                              value: k,
                              checked: _vm._q(_vm.location.map_type, k),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(_vm.location, "map_type", k)
                              },
                            },
                          }),
                          _vm._v(_vm._s(v) + "\n                "),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.location.map_type == 2
                ? _c("p", { staticClass: "help-block m-t-sm" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.google.co.jp/maps/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Googleマップ")]
                    ),
                    _vm._v("から取得した\n              "),
                    _c("strong", [_vm._v("リンクURL")]),
                    _vm._v(" を以下に入力してください。\n            "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.location.map_type == 3
                ? _c("p", { staticClass: "help-block m-t-sm" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.google.co.jp/maps/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Googleマップ")]
                    ),
                    _vm._v("から取得した\n              "),
                    _c("strong", [_vm._v("埋め込みコード")]),
                    _vm._v(" を以下に入力してください。\n            "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.location.map_type == 2
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.location.google_map_url,
                        expression: "location.google_map_url",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "google_map_url",
                      placeholder: "例）https://goo.gl/maps/〜",
                      maxlength: "1000",
                    },
                    domProps: { value: _vm.location.google_map_url },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.location,
                          "google_map_url",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.location.map_type == 3
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.location.google_map_embed,
                        expression: "location.google_map_embed",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "google_map_embed",
                      placeholder:
                        "例）<iframe src=https://www.google.com/maps/〜",
                      maxlength: "1000",
                    },
                    domProps: { value: _vm.location.google_map_embed },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.location,
                          "google_map_embed",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.location.google_map_embed &&
                        _vm.location.map_type == 3,
                      expression:
                        "location.google_map_embed && location.map_type == 3",
                    },
                  ],
                  staticClass: "googlemap_preview m-t-sm",
                },
                [
                  _c("div", {
                    staticClass: "map-content__image longurl",
                    domProps: {
                      innerHTML: _vm._s(_vm.location.google_map_embed),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "form_note m-t-sm" }, [
                    _vm._v(
                      "\n                正しく表示されない場合は、Googleマップの埋め込みコードを再度ご確認ください。\n              "
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-settings btn-lg",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.emitCancelEvent(_vm.modal_id)
                  },
                },
              },
              [_vm._v("\n            キャンセル\n          ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-settings btn-lg",
                attrs: { type: "button", id: "approval_register" },
                on: {
                  click: function ($event) {
                    return _vm.emitAddEvent(_vm.modal_id)
                  },
                },
              },
              [_vm._v("\n            登録\n          ")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }